import { FC, useEffect, useRef, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import Header from "../layouts/header";
import * as Yup from "yup";
import Footer from "../layouts/footer";
import { FormikProps, useFormik } from "formik";
import { AddAndUpdateContactDetails } from "../../Typings/dataListing";
import { usePermissions } from "../../context/PermissionsContext";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { object } from "yup";
import {
  AddContactsData,
  getContactById,
  UpdateContactById,
} from "../../redux/actions/contactAction";
import { errorMsgs } from "../../context/notify";
import formatPhoneNumber from "../../components/formatPhoneNumber";
import DropDownForm from "../../components/DropDownForm";
import {
  fetchCountyData,
  fetchStateData,
} from "../../redux/actions/dataActions";
const ContactsEdit: FC = () => {
  const roleid = localStorage.getItem("roleid") ?? "";
  const { permissions, loading, error } = usePermissions();
  const [state, setstate] = useState<Array<{ label: string; value: string }>>(
    []
  );
  const [County, setCounty] = useState<Array<{ label: string; value: string }>>(
    []
  );
  const [state_option, set_state_Option] = useState<string>("");
  const [county_Option, set_county_Option] = useState<string>("");
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    fetchCountyOptions();
    fetchStateOptions();
  }, [dispatch]);

  const fetchStateOptions = async () => {
    const payload = {
      stateid: null,
      statename: null,
    };
    dispatch(
      fetchStateData(payload, (response: any) => {
        if (response && response.data && Array.isArray(response.data)) {
          const formattedOptions = response.data.map((item: any) => ({
            label: item.statename,
            value: item.statename.toString(),
          }));
          setstate(formattedOptions);
        }
      })
    );
  };

  const fetchCountyOptions = async () => {
    const payload = {
      countyid: null,
      countyname: null,
    };
    dispatch(
      fetchCountyData(payload, (response: any) => {
        if (response && response.data && Array.isArray(response.data)) {
          const formattedOptions = response.data.map((item: any) => ({
            label: item.countyname,
            value: item.countyname.toString(),
          }));
          setCounty(formattedOptions);
        }
      })
    );
  };
  const formik: FormikProps<AddAndUpdateContactDetails> = useFormik({
    initialValues: {
      id: "",
      county: "",
      office: "",
      agent_first_name: "",
      agent_last_name: "",
      title: "",
      address_line_1: "",
      address_line_2: "",
      city: "",
      state: "",
      zip_postal_code: "",
      phone_number: "",
      email_address: "",
      source: "",
    },
    validationSchema: object({
      email_address: Yup.string()
        .email("Invalid format for Email")
        .required("Email is required"),
      phone_number: Yup.string().required("Phone No. is required"),
    }),
    onSubmit: (values, { setSubmitting, setErrors }) => {
      dispatch(
        AddContactsData(values, (response: any) => {
          formik.resetForm();
          try {
            if (response.statusCode === 0) {
              errorMsgs(response.message);
            } else if (response.statusCode === 1) {
              navigate("/farms");
            } else if (response.statusCode === 2) {
              navigate("/farms");
            }
          } catch (error) {
          } finally {
            setSubmitting(false);
          }
        })
      );
    },
  });
  return (
    <div>
      <Header />
      <div className="midCon pb-2">
        <section className="pt-4 pb-4 pt-md-5 pb-md-5">
          <div className="container">
            <div className="loginHd mb-1">
              <span className="d-block">Edit Contacts Information</span>
              {formik.values.id}
            </div>
          </div>
        </section>
        <section className="pt-4 pb-4 pt-md-5 pb-md-5 mt-2 whtBg">
          <div className="container">
            <form onSubmit={formik.handleSubmit}>
              <ul className="d-flex flex-wrap p-0 viewList">
                <li className="col-12 col-sm-6">
                  <div className="position-relative">
                    <span className="field">County</span>
                    <DropDownForm
                      options={County}
                      value={formik.values.county}
                      onChange={(event) =>
                        formik.setFieldValue("county", event.target.value)
                      }
                      className="filterInput"
                      Title="Select County"
                    />
                  </div>
                </li>
                <li className="col-12 col-sm-6">
                  <div className="position-relative">
                    <span className="field">Office</span>
                    <input
                      type="text"
                      name="office"
                      value={formik.values.office}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="loginInput"
                    />
                  </div>
                </li>
                <li className="col-12 col-sm-6">
                  <div className="position-relative">
                    <span className="field">Agent First Name</span>
                    <input
                      type="text"
                      name="agent_first_name"
                      value={formik.values.agent_first_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="loginInput"
                    />
                  </div>
                </li>
                <li className="col-12 col-sm-6">
                  <div className="position-relative">
                    <span className="field">Agent Last Name</span>
                    <input
                      type="text"
                      name="agent_last_name"
                      value={formik.values.agent_last_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="loginInput"
                    />
                  </div>
                </li>
                <li className="col-12 col-sm-6">
                  <div className="position-relative">
                    <span className="field">Title</span>
                    <input
                      type="text"
                      name="title"
                      value={formik.values.title}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="loginInput"
                    />
                  </div>
                </li>
                <li className="col-12 col-sm-6">
                  <div className="position-relative">
                    <span className="field">Address Line 1</span>
                    <input
                      type="text"
                      name="address_line_1"
                      value={formik.values.address_line_1}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="loginInput"
                    />
                  </div>
                </li>
                <li className="col-12 col-sm-6">
                  <div className="position-relative">
                    <span className="field">Address Line 2</span>
                    <input
                      type="text"
                      name="address_line_2"
                      value={formik.values.address_line_2}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="loginInput"
                    />
                  </div>
                </li>
                <li className="col-12 col-sm-6">
                  <div className="position-relative">
                    <span className="field">City</span>
                    <input
                      type="text"
                      name="city"
                      value={formik.values.city}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="loginInput"
                    />
                  </div>
                </li>
                <li className="col-12 col-sm-6">
                  <div className="position-relative">
                    <span className="field">State</span>
                    <DropDownForm
                      options={state}
                      value={formik.values.state}
                      onChange={(event) =>
                        formik.setFieldValue("state", event.target.value)
                      }
                      className="filterInput"
                      Title="Select State"
                    />
                  </div>
                </li>
                <li className="col-12 col-sm-6">
                  <div className="position-relative">
                    <span className="field">ZIP/Postal Code</span>
                    <input
                      type="text"
                      name="zip_postal_code"
                      value={formik.values.zip_postal_code}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="loginInput"
                      pattern="^\d{5}(-\d{4})?$"
                      maxLength={10}
                      title="Enter a valid zip code: 12345 or 12345-6789"
                    />
                  </div>
                </li>
                <li className="col-12 col-sm-6">
                  <div className="position-relative">
                    <span className="field">Phone Number</span>
                    <input
                      type="text"
                      name="phone_number"
                      value={formik.values.phone_number}
                      onChange={(e) => {
                        formik.setFieldValue(
                          "phone_number",
                          formatPhoneNumber(e.target.value)
                        );
                      }}
                      onBlur={formik.handleBlur}
                      className="loginInput"
                      maxLength={12}
                    />
                    {formik.touched.phone_number &&
                      formik.errors.phone_number && (
                        <span className="error">
                          {formik.errors.phone_number}
                        </span>
                      )}
                  </div>
                </li>
                <li className="col-12 col-sm-6">
                  <div className="position-relative">
                    <span className="field">Email Address</span>
                    <input
                      type="text"
                      name="email_address"
                      value={formik.values.email_address}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="loginInput"
                    />
                    {formik.touched.email_address &&
                      formik.errors.email_address && (
                        <span className="error">
                          {formik.errors.email_address}
                        </span>
                      )}
                  </div>
                </li>
                <li className="col-12 col-sm-6">
                  <div className="position-relative">
                    <span className="field">Source</span>
                    <input
                      type="text"
                      name="source"
                      value={formik.values.source}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="loginInput"
                    />
                  </div>
                </li>
              </ul>
              <div className="pt-5 text-end">
                <NavLink
                  to={{
                    pathname: "/Contacts/view/" + formik.values.id,
                  }}
                  title="View"
                >
                  <button type="button" className="formBtn cancel">
                    Cancel
                  </button>
                </NavLink>
                <button type="submit" className="ms-3 formBtn">
                  Save
                </button>
              </div>
            </form>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default ContactsEdit;
